import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateUpdateTaskComponent } from './create-update-task.component';
import { DxAutocompleteModule, DxNumberBoxModule, DxTextAreaModule, DxButtonModule, DxCheckBoxModule, DxDateBoxModule, DxPopupModule, DxScrollViewModule, DxSelectBoxModule, DxSliderModule, DxTagBoxModule, DxTemplateModule, DxTextBoxModule } from 'devextreme-angular';
import { MdbGlobalModule } from '../mdb-global.module';



@NgModule({
  declarations: [CreateUpdateTaskComponent],
  imports: [
    CommonModule,
    MdbGlobalModule,
    DxButtonModule,
    DxNumberBoxModule,
    DxAutocompleteModule,
    DxTextBoxModule,
    DxSelectBoxModule,
    DxTagBoxModule,
    DxDateBoxModule,
    DxSliderModule,
    DxCheckBoxModule,
    DxTemplateModule,
    DxScrollViewModule,
    DxTextAreaModule,
    DxPopupModule
  ],
  exports: [
    CreateUpdateTaskComponent
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class CreateUpdateTaskModule { }
